import React, { useEffect, useRef, useState } from "react";
import data from "../data.json";
import { useLocation, useNavigate, useParams } from "react-router";
import SimpleImageSlider from "react-simple-image-slider";
import { Helmet } from "react-helmet";

function Content() {
  const { date } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const sliderRef = useRef(null);
  const [sliderWidth, setSliderWidth] = useState(0);
  const [isAuthed, setIsAuthed] = useState(
    sessionStorage.getItem("secretAuthed") === "true"
  );

  const selectedContent =
    data.albums.find((album) => album.date === date) ||
    data.secret.find((album) => album.date === date);
  const isSecret =
    data.albums.some((album) => album.date === date && album.type === "secret") ||
    data.secret.some((album) => album.date === date);

  useEffect(() => {
    if (isSecret && !isAuthed) {
      navigate("/auth", { state: { from: location.pathname }, replace: true });
    }
  }, [isAuthed, isSecret, location.pathname, navigate]);

  useEffect(() => {
    setIsAuthed(sessionStorage.getItem("secretAuthed") === "true");
  }, [date]);

  useEffect(() => {
    if (!sliderRef.current) return;

    const resizeObserver = new ResizeObserver(([entry]) => {
      setSliderWidth(Math.floor(entry.contentRect.width));
    });

    resizeObserver.observe(sliderRef.current);
    return () => resizeObserver.disconnect();
  }, []);

  if (!selectedContent || (isSecret && !isAuthed)) return null;

  return (
    <div className="album-article">
      <Helmet>
        <title>
          {selectedContent
            ? `${selectedContent.title} | mini memories`
            : "mini memories"}
        </title>
        {selectedContent && (
          <meta property="og:title" content={selectedContent.title} />
        )}
        {selectedContent && (
          <meta
            property="og:description"
            content="여행의 추억을 기록한 블로그입니다."
          />
        )}
        {selectedContent && (
          <meta
            property="og:image"
            content={`https://i.imgur.com/${selectedContent.image[0]}.jpeg`}
          />
        )}
        {selectedContent && (
          <meta property="og:url" content={`https://mini.gyeong.net/${date}`} />
        )}
        {selectedContent && <meta property="og:type" content="article" />}
      </Helmet>
      <div className="album-article-images" ref={sliderRef}>
        {sliderWidth > 0 && (
          <SimpleImageSlider
            width={sliderWidth}
            height={sliderWidth}
            images={selectedContent.image.map((image) => ({
              url: `https://i.imgur.com/${image}.jpeg`,
            }))}
            showBullets={true}
            showNavs={true}
          ></SimpleImageSlider>
        )}
      </div>
      <div className="album-article-info">
        <div className="album-article-date">
          <span>{selectedContent.date}</span>
          <span className="dayStyle-content">{selectedContent.day}</span>
        </div>
        <div className="album-article-title">{selectedContent.title}</div>
        <div className="album-article-description">{selectedContent.content}</div>
      </div>
    </div>
  );
}

export default Content;
